import { createServiceToken } from '@ochal/module-sdk/contracts';
import type { ApiClient } from './client';
export const API_CLIENT = createServiceToken<ApiClient>('platform.api-client');
